import React, { useEffect, useRef, useState } from 'react';
import { Alert, Spinner } from 'reactstrap';
import { Button, Col, Icon, Row, RSelect } from '../../../../../../components/Component';
import { convertPackagingUnits, retreive_rSelectVariables } from '../../../../../../utils/functionalUtils';
import { messageToast, rSelectMapFun } from '../../../../../../utils/Utils';
import TextInput from '../../../../../components/inputs/TextInput';
import { useDispatch } from 'react-redux';
import { ADD_PRODUCT_TO_LOADING_ORDER_API, RETRIEVE_ACTIVE_AVAILABLE_PRODUCTS_API, RETRIEVE_ACTIVE_EMPLOYEE_BRANCH_LOCATION_LIST_API, RETRIEVE_USER_ACCOUNT_PROPERTIES_BY_UNIQUE_ID_API } from '../../../../../../api/api_data';
import { employee_dashboard_actions_helper } from '../../../../../../actions/actions_helper';
import { fail_product_list, loading_product_list, reset_product_list, success_product_list } from '../../../../../../reducers/dashboard_reducers/products/product_list_Slice';
import { ADD_LOADING_ORDER_PRODUCT_ACCESS_DENIED_MSG, ADD_LOADING_ORDER_PRODUCT_ERR_MSG, ADD_LOADING_ORDER_PRODUCT_SUCCESS_MSG, RETRIEVE_BRANCH_LOCATION_LIST_ACCESS_DENIED_MSG, RETRIEVE_BRANCH_LOCATION_LIST_ERR_MSG, RETRIEVE_BRANCH_LOCATION_LIST_SUCCESS_MSG, RETRIEVE_PRODUCTS_LIST_ACCESS_DENIED_MSG, RETRIEVE_PRODUCTS_LIST_ERR_MSG, RETRIEVE_PRODUCTS_LIST_SUCCESS_MSG, RETRIEVE_USER_ACCOUNT_PROPERTY_LIST_ACCESS_DENIED_MSG, RETRIEVE_USER_ACCOUNT_PROPERTY_LIST_ERR_MSG, RETRIEVE_USER_ACCOUNT_PROPERTY_LIST_SUCCESS_MSG } from '../../../../../../constants/success_error_messages_consts';
import * as app_consts from "../../../../../../constants/react_app_consts";
import { useSelector } from 'react-redux';
import { fail_branch_location_list, loading_branch_location_list, reset_branch_location_list, success_branch_location_list } from '../../../../../../reducers/dashboard_reducers/branch_locations/branch_location_list_Slice';
import ListText from '../../../text/ListText';
import { fail_add_product_to_loading_order, loading_add_product_to_loading_order, reset_add_product_to_loading_order, success_add_product_to_loading_order } from '../../../../../../reducers/dashboard_reducers/loading_orders/add_product_to_loading_order_Slice';
import { useNavigate } from 'react-router';

const initialState = { product_id: "", product_type: "", product: "", warehouse_storage_type_id: "", warehouse_storage: "", total_capacity_selected_measurement: "", total_capacity_in_mt: "", uom: "", uom_label: "", warehouse_storage_label: "", branch_location_id: "", branch_location_label: "", available_capacity: "", delivery_location: "", loading_order_ref_no: "", packet_size: "", packet_measurement_in_kilos: "" };

const buildLoadingOrderProductDraft = (formData) => ({
 product_name: formData?.product,
 delivery_name: formData?.delivery_location,
 branch_location: formData?.branch_location_label,
 packet_size: formData?.packet_size,
 total_capacity_selected_measurement: formData?.total_capacity_selected_measurement,
 total_mt_capacity: formData?.total_capacity_in_mt,
 product_status: app_consts.NOT_LOADED,
});

const AddLoadingOrderProduct = ({ page_data, openModal, successFunction, wizard_data }) => {

 const [step, setStep] = useState(1);
 const [formData, setFormData] = useState(initialState);
 const [errorVal, setError] = useState("");
 const [productTypeList, setProductTypeList] = useState([]);
 const [productListLoading, setProductListLoading] = useState(true);
 const [selectedProducts, setSelectedProducts] = useState();
 const [product_data, setProductData] = useState([]);
 const [productsList, setProductsList] = useState([]);
 const [uom, setUom] = useState([]);
 const dispatch = useDispatch();
 const [branches, setBranches] = useState([]);
 const [warehousestorageslist, setWarehouseStoragesList] = useState([]);
 const [addLoading, setAddLoading] = useState(false);
 const [packet_size_list, setPacketSizeList] = useState([]);
 const navigate = useNavigate();
 const hasHandledSubmitResult = useRef(false);

 // Code that Runs When Page Opens
 useEffect(() => {
  // setRetrievedData(page_data);
  if (openModal && page_data)
  {
   setFormData({ ...formData, ["loading_order_ref_no"]: page_data?.loading_order_ref_no });

   // Retrieve Product List
   dispatch(
    employee_dashboard_actions_helper(
     loading_product_list,
     success_product_list,
     fail_product_list,
     RETRIEVE_PRODUCTS_LIST_ERR_MSG,
     RETRIEVE_PRODUCTS_LIST_SUCCESS_MSG,
     app_consts.GET,
     RETRIEVE_ACTIVE_AVAILABLE_PRODUCTS_API,
     null,
     RETRIEVE_PRODUCTS_LIST_ACCESS_DENIED_MSG
    )
   );
  }
 }, [openModal, page_data]);

 //Listen to State of Product List
 const product_list = useSelector((state) => state.product_list.product_list);

 useEffect(() => {
  if (product_list.status !== app_consts.IDLE)
  {
   if (product_list.status === app_consts.LOADING)
   {
    setProductListLoading(true);
   } else
   {
    setProductListLoading(false);
    if (product_list.status === app_consts.FAIL)
    {
     messageToast(product_list.message, app_consts.FAIL);
    } else if (product_list.status === app_consts.SUCCESS)
    {
     setProductData(product_list.data);
    }
    dispatch(reset_product_list());
   }
  }
 }, [product_list]);

 // Product Data listener
 useEffect(() => {
  if (product_data) 
  {
   handleProductType();
  }
 }, [product_data]);

 const handleProductType = async () => {
  let mappedData = [];
  const uniqueSet = new Set();

  await Promise.all(
   product_data?.map(async (data_to_map) => {
    const { label, value } = retreive_rSelectVariables(app_consts.PRODUCT_TYPE_MAP, data_to_map);
    const result = await rSelectMapFun(label, value);


    const uniqueIdentifier = result.value;
    if (!uniqueSet.has(uniqueIdentifier))
    {
     uniqueSet.add(uniqueIdentifier);
     mappedData.push(result);
    }
   })
  );

  setProductTypeList(mappedData);
 };

 // Handle Product Type Change
 const handleProductTypeChange = async (value, label) => {
  if (value && label) 
  {
   setFormData({ ...formData, ["product_type"]: label, ["product_id"]: "", ["product"]: "", ["warehouse_storage_type_id"]: "", ["total_capacity_selected_measurement"]: "", ["total_capacity_in_mt"]: "", ["warehouse_storage_label"]: "", ["uom"]: "", ["uom_label"]: "" });
   let mappedData = [];
   const uniqueSet = new Set();

   const filtereredData = product_data?.filter((data) => data.product_type_id === value);

   setSelectedProducts(filtereredData);

   await Promise.all(
    filtereredData?.map(async (data_to_map) => {
     const { label, value } = retreive_rSelectVariables(app_consts.PRODUCTS_MAP, data_to_map);
     const result = await rSelectMapFun(label, value);

     const uniqueKey = JSON.stringify(result);

     if (!uniqueSet.has(uniqueKey))
     {
      uniqueSet.add(uniqueKey);
      mappedData.push(result);
     }
    })
   );

   setProductsList(mappedData);
  }
  else
  {
   setFormData({ ...formData, ["product_type"]: "", ["product_id"]: "", ["product"]: "", ["warehouse_storage_type_id"]: "", ["total_capacity_selected_measurement"]: "", ["total_capacity_in_mt"]: "", ["warehouse_storage_label"]: "", ["uom"]: "", ["uom_label"]: "" });
  }
 };

 // Handle Branch Location Change
 const handleBranchLocationChange = async (value, label) => {
  if (value && label) 
  {
   setFormData({ ...formData, ["branch_location_label"]: label, ["branch_location_id"]: value, ["warehouse_storage_type_id"]: "", ["warehouse_storage_label"]: "", ["available_capacity"]: "", ["packet_size"]: "" });
   let mappedData = [];
   const uniqueSet = new Set();

   const filtereredData = product_data?.filter((data) => data.product_id === formData.product_id && data.product_type === formData.product_type && formData.uom === data.unit_measurement_id && data.branch_location_id === value);

   setSelectedProducts(filtereredData);

   await Promise.all(
    filtereredData?.map(async (data_to_map) => {
     const { label, value } = retreive_rSelectVariables(app_consts.WAREHOUSE_STORAGE_TYPES_MAP, data_to_map);
     const result = await rSelectMapFun(label, value);

     const uniqueKey = JSON.stringify(result);

     if (!uniqueSet.has(uniqueKey))
     {
      uniqueSet.add(uniqueKey);
      mappedData.push(result);
     }
    })
   );
   setWarehouseStoragesList(mappedData);
  }
  else
  {
   setFormData({ ...formData, ["warehouse_storage_type_id"]: "", ["warehouse_storage_label"]: "", ["available_capacity"]: "", ["branch_location_label"]: "", ["branch_location_id"]: "", ["packet_size"]: "" });
  }
 };

 // Handle Product Change
 const handleProductChange = async (value, label) => {
  if (value && label) 
  {
   setFormData({ ...formData, ["product_id"]: value, ["product"]: label, ["warehouse_storage_type_id"]: "", ["total_capacity_selected_measurement"]: "", ["total_capacity_in_mt"]: "", ["warehouse_storage_label"]: "", ["uom"]: "", ["uom_label"]: "", ["branch_location_label"]: "", ["branch_location_id"]: "", ["packet_size"]: "" });
   let mappedData = new Set();

   const filtereredData = product_data?.filter((data) => data.product_id === value && data.product_type === formData.product_type);

   await Promise.all(
    filtereredData?.map(async (data_to_map) => {
     // Map Pum Liist
     const { label, value } = retreive_rSelectVariables(app_consts.UOM_MAP, data_to_map);
     const result = await rSelectMapFun(label, value);

     // Serialize only valid JSON objects
     const stringifiedResult = JSON.stringify(result);
     if (stringifiedResult)
     {
      mappedData.add(stringifiedResult); // Add unique stringified objects
     }
    })
   );
   const uniqueMappedData = Array.from(mappedData, (item) => JSON.parse(item));
   setUom(uniqueMappedData);
  }
  else
  {
   setFormData({ ...formData, ["product_id"]: "", ["product"]: "", ["warehouse_storage_type_id"]: "", ["total_capacity_selected_measurement"]: "", ["total_capacity_in_mt"]: "", ["warehouse_storage_label"]: "", ["uom"]: "", ["uom_label"]: "", ["branch_location_label"]: "", ["branch_location_id"]: "", ["packet_size"]: "" });
  }
 };

 // Handle Unit of Measurem Chanage
 const handleUomChange = async (value, label) => {
  if (value && label) 
  {
   let branchDataMap = [];

   setFormData({ ...formData, ["warehouse_storage_type_id"]: "", ["total_capacity_selected_measurement"]: "", ["total_capacity_in_mt"]: "", ["warehouse_storage_label"]: "", ["uom"]: value, ["uom_label"]: label, ["packet_size"]: "" });

   const filtereredData = product_data?.filter((data) => data.product_id === formData.product_id && data.product_type === formData.product_type && value === data.unit_measurement_id);

   const uniqueSet = new Set();

   await Promise.all(
    filtereredData?.map(async (data_to_map) => {
     // Map Branch List
     const { label, value } = retreive_rSelectVariables(app_consts.BRANCH_LOCATION_MAP, data_to_map);
     const result = await rSelectMapFun(label, value);

     const uniqueKey = JSON.stringify(result);

     if (!uniqueSet.has(uniqueKey))
     {
      uniqueSet.add(uniqueKey);
      branchDataMap.push(result);
     }
    })
   );

   setBranches(branchDataMap);
  }
  else
  {
   setFormData({ ...formData, ["warehouse_storage_type_id"]: "", ["total_capacity_selected_measurement"]: "", ["total_capacity_in_mt"]: "", ["warehouse_storage_label"]: "", ["uom"]: "", ["uom_label"]: "", ["packet_size"]: "" });
  }
 };

 // Handle Change
 const handleChange = (e) => {
  if (e.target.name === "total_capacity_selected_measurement")
  {

   // Convert to Metric Tonnes
   const metric_tonne_conversion = parseFloat(
    ((formData?.packet_measurement_in_kilos || 0) / 1000) * Number(e.target.value)
   ).toFixed(2);

   setFormData({ ...formData, ["total_capacity_in_mt"]: metric_tonne_conversion, ["total_capacity_selected_measurement"]: e.target.value });
  }
  else
  {
   setFormData({ ...formData, [e.target.name]: e.target.value });
  }
 };

 const handleOnblur = (e) => {
  if (e.target.name === "total_capacity_in_mt")
  {
   if (e.target.value)
   {
    setFormData({ ...formData, ["total_capacity_in_mt"]: parseFloat(e.target.value).toFixed(2) });
   }
   else
   {
    setFormData({ ...formData, ["total_capacity_in_mt"]: "" });
   }
  }
  else
  {
   if (e.target.value)
   {
    setFormData({ ...formData, [e.target.name]: parseFloat(e.target.value).toFixed(2) });
   }
   else
   {
    setFormData({ ...formData, [e.target.name]: "" });
   }
  }
 };

 // Handle Storage Type Change
 const handleStorageTypeChange = async (value, label) => {
  if (value && label) 
  {


   const filteredData = product_data?.filter((data) => data.product_id === formData.product_id && data.product_type === formData.product_type && formData.uom === data.unit_measurement_id && data.branch_location_id === formData.branch_location_id && data.warehouse_storage_type_id === value);

   setFormData({ ...formData, ["warehouse_storage_type_id"]: value, ["total_capacity_selected_measurement"]: "", ["total_capacity_in_mt"]: "", ["warehouse_storage_label"]: label, ["available_capacity"]: "", ["packet_size"]: "" });

   // Filter Out Available Packet Size
   let mappedData = [];
   // Using a Set to store unique results
   const uniqueSet = new Set();

   await Promise.all(
    filteredData?.map(async (data_to_map) => {
     const { label, value } = retreive_rSelectVariables(app_consts.ADD_LOADING_ORDER_PACKET_SIZE, data_to_map);
     const result = await rSelectMapFun(label, value);
     // Convert result to a string for uniqueness comparison
     const uniqueKey = JSON.stringify(result);

     if (!uniqueSet.has(uniqueKey))
     {
      uniqueSet.add(uniqueKey); // Add to the set
      mappedData.push(result); // Add to the array
     }
    })
   );
   setPacketSizeList(mappedData);
  }
  else
  {
   setFormData({ ...formData, ["warehouse_storage_type_id"]: "", ["total_capacity_selected_measurement"]: "", ["total_capacity_in_mt"]: "", ["warehouse_storage_label"]: "", ["packet_size"]: "" });
  }
 };

 // Handle Preview
 const handlePreview = () => {
  setError("");
  setStep(2);
 };

 //     // Handle Submit
 const handleSubmit = () => {
  setError("");
  dispatch(
   employee_dashboard_actions_helper(
    loading_add_product_to_loading_order,
    success_add_product_to_loading_order,
    fail_add_product_to_loading_order,
    ADD_LOADING_ORDER_PRODUCT_ERR_MSG,
    ADD_LOADING_ORDER_PRODUCT_SUCCESS_MSG,
    app_consts.POST,
    ADD_PRODUCT_TO_LOADING_ORDER_API,
    { ...formData, ["loading_order_ref_no"]: page_data?.loading_order_ref_no },
    ADD_LOADING_ORDER_PRODUCT_ACCESS_DENIED_MSG
   )
  );
 };

 // Listen to the Changes
 const product_add_listener = useSelector((state) => state.add_product_to_loading_order.add_product_to_loading_order);

 useEffect(() => {
  if (!openModal)
  {
   return;
  }

  if (product_add_listener.status !== app_consts.IDLE)
  {
   if (product_add_listener.status === app_consts.LOADING)
   {
    hasHandledSubmitResult.current = false;
    setError("");
    setAddLoading(true);
   } else
   {
    if (hasHandledSubmitResult.current)
    {
     return;
    }

    hasHandledSubmitResult.current = true;
    setAddLoading(false);
    if (product_add_listener.status === app_consts.FAIL)
    {
     messageToast(product_add_listener.message, app_consts.FAIL);
     setError(product_add_listener.message);
    } else if (product_add_listener.status === app_consts.SUCCESS)
    {
     const fallbackProductData = buildLoadingOrderProductDraft(formData);
     const loadingOrderRefNo =
      product_add_listener.data?.loading_order_ref_no || page_data?.loading_order_ref_no;

     dispatch(reset_add_product_to_loading_order());

     if (loadingOrderRefNo)
     {
      navigate(`/dashboard/loading_orders/${loadingOrderRefNo}`, { replace: true });
     }
     else
     {
      successFunction(product_add_listener.data || fallbackProductData);
     }
     return;
    }
    dispatch(reset_add_product_to_loading_order());
   }
  }
 }, [dispatch, formData, navigate, openModal, page_data?.loading_order_ref_no, product_add_listener, successFunction]);



 const handlePacketSizeChange = async (value, label) => {
  if (value && label) 
  {
   const filteredData = product_data?.filter((data) => data.product_id === formData.product_id && data.product_type === formData.product_type && formData.uom === data.unit_measurement_id && data.branch_location_id === formData.branch_location_id && data.warehouse_storage_type_id === formData?.warehouse_storage_type_id && data.uom_description === value);


   setFormData({ ...formData, ["packet_measurement_in_kilos"]: filteredData[0]?.packet_measurement_in_kilos, ["packet_size"]: value, ["total_capacity_in_mt"]: "", ["total_capacity_selected_measurement"]: "", ["available_capacity"]: filteredData[0]?.available_capacity || 0.00 });
  }
  else
  {
   setFormData({ ...formData, ["packet_measurement_in_kilos"]: "", ["packet_size"]: "", ["total_capacity_in_mt"]: "", ["total_capacity_selected_measurement"]: "", ["available_capacity"]: "" });
  }
 };

 const getSelectedOption = (value, options) => {
  return options.find(option => option.value === value) || null;
 };

 return (
  <>
   <div className="d-flex justify-content-between mb-2">
    {step === 2 && (
     <div
      className="nk-block-head-sub mb-2"
      style={{ cursor: "pointer" }}
      onClick={(e) => {
       e.preventDefault();
       setStep(1);
       setFormData(initialState);
      }}
     >
      <Icon name="arrow-left" />
      <span>back</span>
     </div>
    )}
   </div>
   {errorVal && (
    <div className="mb-3 w-100">
     <Alert color="danger" className="alert-icon">
      <Icon name="alert-circle" /> {errorVal}{" "}
     </Alert>
    </div>
   )}
   {step === 1 ? (
    <>
     <form
      onSubmit={(e) => {
       e.preventDefault();
      }}
     >
      <Row className="g-4">
       <div className="form-label-group">
        <label className="form-label text-soft fs-22px">Product Details</label>
       </div>
       <Col size={6} className="my-2">
        <div className="form-group">
         <label className="form-label" htmlFor="">
          Product Type
         </label>
         <div className="w-100 form-control-wrap d-flex flex-row justify-content-between align-items-center">
          <div className="w-100">
           <RSelect
            options={productTypeList}
            className="w-100"
            placeholder="Search"
            id="product_type"
            isLoading={productListLoading}
            onChange={(e) => { handleProductTypeChange(e.value, e.label); }}
            isDisabled={productListLoading}
           />
          </div>
         </div>
        </div>
       </Col>
       <Col size={6} className="my-2">
        <div className="form-group">
         <label className="form-label" htmlFor="">
          Product
         </label>
         <div className="w-100 form-control-wrap d-flex flex-row justify-content-between align-items-center">
          <div className="w-100">
           <RSelect
            options={productsList}
            className="w-100"
            placeholder="Search"
            id="product_id"
            onChange={(e) => { handleProductChange(e.value, e.label); }}
            isDisabled={!formData.product_type}
            value={getSelectedOption(formData.product_id, productsList)}
           />
          </div>
         </div>
        </div>
       </Col>
       <Col size={6} className="my-2">
        <div className="form-group">
         <label className="form-label" htmlFor="uom">
          Unit of Measure
         </label>
         <div className="w-100 form-control-wrap d-flex flex-row justify-content-between align-items-center">
          <div className="w-100">
           <RSelect
            options={uom}
            className="w-100"
            placeholder="Search"
            id="uom"
            onChange={(e) => { handleUomChange(e.value, e.label); }}
            isDisabled={!formData.product_id}
            value={getSelectedOption(formData.uom, uom)}
           />
          </div>
         </div>
        </div>
       </Col>
       <TextInput
        parentClassName="mt-2"
        label="Delivery Location"
        id_val="delivery_location"
        type="text"
        value={formData?.delivery_location}
        colSize="6"
        name="delivery_location"
        handleChange={handleChange}
       />
       <div className="form-label-group">
        <label className="form-label text-soft fs-22px">Warehouse Details</label>
       </div>
       <Col size={6} className="my-2">
        <div className="form-group">
         <label className="form-label" htmlFor="">
          Branch Location
         </label>
         <div className="w-100 form-control-wrap d-flex flex-row justify-content-between align-items-center">
          <div className="w-100">
           <RSelect
            options={branches}
            className="w-100"
            placeholder="Search"
            id="product_type"
            isLoading={productListLoading}
            onChange={(e) => { handleBranchLocationChange(e.value, e.label); }}
            isDisabled={!formData.uom}
            value={getSelectedOption(formData.branch_location_id, branches)}
           />
          </div>
         </div>
        </div>
       </Col>
       <Col size={6} className="my-2">
        <div className="form-group">
         <label className="form-label" htmlFor="">
          Storage Type
         </label>
         <div className="w-100 form-control-wrap d-flex flex-row justify-content-between align-items-center">
          <div className="w-100">
           <RSelect
            options={warehousestorageslist}
            className="w-100"
            placeholder="Search"
            id="warehouse_storage_type_id"
            isLoading={productListLoading}
            onChange={(e) => { handleStorageTypeChange(e.value, e.label); }}
            isDisabled={!formData.branch_location_id}
            value={getSelectedOption(formData.warehouse_storage_type_id, warehousestorageslist)}
           />
          </div>
         </div>
        </div>
       </Col>
       <Col size={6} className="my-2">
        <div className="form-group">
         <label className="form-label" htmlFor="warehouse_storage_type_id">
          Packet Size
         </label>
         <div className="w-100 form-control-wrap d-flex flex-row justify-content-between align-items-center">
          <div className="w-100">
           <RSelect
            options={packet_size_list}
            className="w-100"
            placeholder="Search"
            id="warehouse_storage_type_id"
            onChange={(e) => { handlePacketSizeChange(e.value, e.label); }}
            isDisabled={!formData.warehouse_storage_type_id}
            value={getSelectedOption(formData.packet_size, packet_size_list)}
           />
          </div>
         </div>
        </div>
       </Col>
       <TextInput
        parentClassName="mt-2"
        label="Quantity Available (MT)"
        id_val="available_capacity"
        type="number"
        value={formData?.available_capacity}
        colSize="6"
        name="available_capacity"
        disabled={true}
        handleChange={handleChange}
       />
       <div className="form-label-group">
        <label className="form-label text-soft fs-22px">Measurement Details</label>
       </div>
       <TextInput
        parentClassName="mt-2"
        label={`Package/Container Number`}
        id_val="total_capacity_selected_measurement"
        type="number"
        value={formData?.total_capacity_selected_measurement}
        colSize="6"
        name="total_capacity_selected_measurement"
        handleChange={handleChange}
        onBlur={handleOnblur}
        disabled={!formData.uom}
       />
       <TextInput
        parentClassName="mt-2"
        label="Quantity in (MT)"
        id_val="total_capacity_in_mt"
        maxlength="160"
        type="number"
        value={formData?.total_capacity_in_mt}
        colSize="6"
        name="total_capacity_in_mt"
        disabled={true}
        handleChange={handleChange}
        onBlur={handleOnblur}
       />
       <Col xl="12" className="d-flex justify-content-center">
        <Button
         onClick={handlePreview}
         size="lg"
         type="submit"
         color="primary"
         disabled={!(formData.product_id && formData.warehouse_storage_type_id && formData.total_capacity_selected_measurement && formData.delivery_location && formData.total_capacity_in_mt && formData.uom && formData.branch_location_id)}
        >
         Preview Product and Add
        </Button>
       </Col>
      </Row>
     </form>
    </>
   )
    :
    <>
     <ListText dataItem="data-item mySmall" label="Product Name" value={formData.product} />
     <ListText dataItem="data-item mySmall" label="Product Type" value={formData.product_type} />
     <ListText dataItem="data-item mySmall" label="Warehouse Storage Type" value={formData.warehouse_storage_label} />
     <ListText dataItem="data-item mySmall" label="Unit of Measurement" value={formData.uom_label} />
     <ListText dataItem="data-item mySmall" label="Branch Location" value={formData.branch_location_label} />
     <ListText dataItem="data-item mySmall" label="Delivery Location" value={formData.delivery_location} />
     <ListText dataItem="data-item mySmall" label="Packet Size" value={formData.packet_size} />
     <ListText dataItem="data-item mySmall" label={`Total Capacity ${formData.unit_measurement ? `(${formData.unit_measurement})` : ""}`} value={formData.total_capacity_selected_measurement} />
     <ListText dataItem="data-item mySmall" label="Total Capacity (MT)" value={formData.total_capacity_in_mt} />
     <Col xl="12" className="d-flex justify-content-end mt-4 mr-2">
      <Button onClick={handleSubmit} disabled={addLoading} color="primary">
       {addLoading ? <Spinner size="sm" color="light" /> : "Add Product"}
      </Button>
     </Col>
    </>
   }
  </>
 );
};

export default AddLoadingOrderProduct;
